export default "### Tested by experts\n\nEvery car passes a 300 point check and is inspected and test-driven by certified technicians.\n";